import { FunctionalComponent, h } from '@stencil/core';

export const enum StoryTitleType {
  DEFAULT = 'normal',
  COUNTER = 'counter',
  QUOTED = 'quoted',
}

export const enum StoryCounterType {
  DEFAULT = 'default',
  PERCENTAGE = 'percentage',
  INTEGER = 'integer',
}

export interface StoryProps {
  storyTitle?: string;
  storyLabel?: string;
  counterTarget?: number;
  counterType?: StoryCounterType;
  storyType?: StoryTitleType;
}

export const Story: FunctionalComponent<StoryProps> = ({ storyTitle, storyLabel, counterTarget, counterType, storyType }, children) => {
  return (
    <rudy-modules-story storyTitle={storyTitle} storyLabel={storyLabel} counterTarget={counterTarget} counterType={counterType} storyType={storyType}>
      {children}
    </rudy-modules-story>
  );
};
